const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const EditPencil = require("./EditPencil");
const UnderlineView = require("./UnderlineView");
const CopyTable = require("./data/CopyTable");
const Analytics = require("../core/util/Analytics");

const styles = require("./styles/Editable.css");

module.exports = createReactClass({
	displayName: "Editable",

	propTypes: {
		className: PT.string,
		inputClassName: PT.string,
		text: PT.oneOfType([PT.string, PT.object]).isRequired,
		onSave: PT.func,
		checkContent: PT.func,
		checkType: PT.string,
		hideControls: PT.bool,
		useUnderline: PT.bool,
		allowedCharacters: PT.string,
		cannotSaveEmpty: PT.bool, // Must have something in entry
		maxLength: PT.number,
		placeholder: PT.string,
		// Instead of editing, clicking on pencil does onClick action
		onClick: PT.func,
		// the following for special cases (i.e. when multiple editables need to
		// be updated at once - see ManageTab).
		onEdit: PT.func,
		onUpdate: PT.func,
		isEditing: PT.bool,
		editContainerClass: PT.string,
	},

	getInitialState: function() {
		return {
			text: this.props.text,
			error: null,
			isEditing: !!this.props.isEditing,
		};
	},

	UNSAFE_componentWillReceiveProps: function(nextProps) {
		const {text, isEditing} = this.props;
		if (text !== nextProps.text || isEditing !== nextProps.isEditing) {
			this.setState({
				text: nextProps.text,
				isEditing: !!nextProps.isEditing,
			});
		}
	},

	onEdit: function() {
		this.setState({isEditing: true});
	},

	onChange: function(evt) {
		let val = evt.target.value;
		if (this.props.allowedCharacters) {
			const pattern = new RegExp(`[^${this.props.allowedCharacters}]$`);
			val = val.replace(pattern, "");
		}
		if (this.props.onUpdate) {
			this.props.onUpdate(val);
		} else {
			this.setState({text: val});
		}
	},

	handleKeyPress: function(evt) {
		if (evt.which === 13) {
			// on enter
			this.onSave();
		}
	},

	onSave: function() {
		let text = this.state.text;
		const {onSave, checkContent, cannotSaveEmpty} = this.props;
		if (cannotSaveEmpty && !text) {
			// revert to original text
			text = this.props.text;
		}
		const error = checkContent && checkContent(text);
		if (!error) {
			onSave(text);
			this.setState({text, isEditing: false, error: null});
		} else {
			this.setState({error});
		}
	},

	render: function() {
		const {
			hideControls,
			className,
			inputClassName,
			useUnderline,
			onEdit,
			onClick,
			maxLength,
			checkType,
			editContainerClass,
			placeholder,
		} = this.props;
		const {isEditing, text, error} = this.state;
		const hotjarSuppressionAttributes = Analytics.getHotjarSuppressionAttributes();

		const nameClass = hideControls ? styles.nameInput : styles.nameInputSmaller;
		let iClassName = inputClassName || nameClass;
		iClassName += " " + styles.inputColor;
		let mainClass = styles.main;
		if (className) mainClass += " " + className;
		let containerClass = styles.editContainer;
		if (editContainerClass) containerClass += " " + editContainerClass;

		let errorEl;
		if (isEditing) {
			if (error) {
				errorEl = (
					<div className={styles.error}>
						{"* " + CopyTable.getFormInvalidCopy(checkType)[error]}
					</div>
				);
			}
			return (
				<div className={mainClass}>
					{!hideControls && (
						<div className={styles.saveContainer}>
							<div className={styles.saveButton} onClick={this.onSave}>
								Save
							</div>
						</div>
					)}
					<input
						className={iClassName}
						value={text}
						placeholder={placeholder}
						onChange={this.onChange}
						onKeyPress={this.handleKeyPress}
						maxLength={maxLength}
						{...hotjarSuppressionAttributes}
					/>
					{errorEl}
				</div>
			);
		}

		const isPlaceholder = placeholder && !text;
		const displayText = isPlaceholder ? placeholder : text;
		const textEl = useUnderline ? (
			<UnderlineView text={displayText} />
		) : (
			displayText
		);
		const editPencil = hideControls ? null : (
			<div className={containerClass}>
				<EditPencil onClick={onClick || onEdit || this.onEdit} />
			</div>
		);
		const textClass = isPlaceholder
			? styles.text + " " + styles.placeholderText
			: styles.text;

		return (
			<div className={mainClass}>
				{editPencil}
				<div className={textClass} {...hotjarSuppressionAttributes}>
					{textEl}
				</div>
			</div>
		);
	},
});
